var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:( _obj = {}, _obj[_vm.$style.flipHorizontal] = this.directionLeft(), _obj ),attrs:{"viewBox":"0 0 16 16","fill":"none","width":"20","height":"20"}},[_c('path',{class:_vm.pathCssClass,attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.707 2 5 2.706l4.95 4.95L5 12.607l.707.708 5.657-5.657L5.707 2Z","fill":"#000"}})])}
var staticRenderFns = []

export { render, staticRenderFns }